import React from 'react';
import { TabDescriptor } from '../types';
import { UnreadCounts } from '../../../services/messagerie/useUnreadCounts';

interface CommandeTabsProps {
  descriptors: TabDescriptor[];
  activeIndex: number;
  onSelect: (index: number) => void;
  unreadCounts?: UnreadCounts | null;
}

// Survol d'un onglet DESACTIVE : dit QUAND l'onglet s'ouvrira (oriente deblocage). Meme vocabulaire
// que la vue acheteur BC (parite), calque sur le MS. Un onglet actif n'a pas de survol.
const tooltipFor = (tab: TabDescriptor): string => {
  if (tab.inactive) return 'Fonctionnalité en cours de développement';
  if (!tab.disabled) return '';
  switch (tab.kind) {
    case 'notification':
    case 'messagerie':
    case 'evaluation':
      return 'Disponible dès le bon de commande signé';
    case 'offre':
      // Miroir presta du message acheteur : l'offre s'ouvre quand la consultation est lancee. Pas de
      // rang cite ici — la commande du presta EST deja scopee a son rang, l'afficher n'apprendrait rien.
      return 'Disponible dès la consultation lancée';
    default:
      return 'Non disponible dans ce statut';
  }
};

// Nombre de non-lus a afficher en badge pour un onglet (0 = pas de badge). BDC : messagerie seule.
const badgeCountFor = (tab: TabDescriptor, unreadCounts?: UnreadCounts | null): number => {
  if (!unreadCounts) return 0;
  return tab.kind === 'messagerie' ? unreadCounts.messagerie : 0;
};

// Barre d'onglets presta : boutons CUSTOM calques sur OperationTabs (case acheteur), pour une
// parite VISUELLE exacte (soulignement orange #f97316, tooltips disabled/inactive). N'utilise
// PLUS le composant partage TabNav. Pilotee par descripteurs types : pas d'index magique, pas
// de regex ; disabled/inactive sont calcules en domaine puis lus tels quels.
const CommandeTabs: React.FC<CommandeTabsProps> = ({ descriptors, activeIndex, onSelect, unreadCounts }) => (
  <div className="scbc__tab-nav">
    <div className="scbc__tab-nav-left">
      {descriptors.map((tab, index) => {
        const locked = tab.disabled || tab.inactive;
        const tooltip = tooltipFor(tab);
        const badge = badgeCountFor(tab, unreadCounts);
        const classes = ['scbc__tab-button'];
        if (index === activeIndex) classes.push('active');
        if (tab.inactive) classes.push('inactive');
        if (tab.disabled) classes.push('disabled');

        return (
          <button
            key={tab.key}
            type="button"
            className={classes.join(' ')}
            onClick={() => !locked && onSelect(index)}
            disabled={locked}
            title={tooltip}
            data-tooltip={tooltip}
          >
            {tab.label}
            {badge > 0 && <span className="scbc__tab-badge">{badge}</span>}
          </button>
        );
      })}
    </div>
  </div>
);

export default CommandeTabs;
